import { Link } from 'react-router-dom';
import { useEffect, useState } from "react";
import { client } from "../data/client";
import dayjs from 'dayjs';
import { Icon } from "@iconify/react"; // check out https://icon-sets.iconify.design/ for icon list
import '../styles/retro.scss'
import usePageTitle from '../hooks/usePageTitle';

const THEME_QUERY = `*[_type == "season" && startDate != endDate] | order(startDate asc){
  name,
  slug,
  startDate,
  endDate,
  summary,
  "themes": themes[]->{
    name,
    slug,
    description,
    theme_react_icon
  }
}`;

function RetroTime() {
  const [seasons, setSeasons] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    client.fetch(THEME_QUERY)
      .then((data) => {
        setSeasons(data);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching seasons:", error);
        setLoading(false);
      });
  }, []);

  usePageTitle('Retro Grouping by Dates/Seasons | Dochano');

  if (loading) return <p id="Retro">Loading themes...</p>;

  return (
    <section id="Retro">
      <div id="Intro">
        <h1>Retrospective Dates and Seasons</h1>
      </div>
      <p>I am using Sanity.io to hold the Retrospective data used here. I have found that my team enjoys Retrospectives that closely represent the happenings of the world or the team member personally. That has had me focus on Retrospective Timings to pull meaningful Themes. One that I am particularly fond of is the "<Link to="../theme/right-to-vote">Right to Vote</Link>" theme to encourage people to vote come November.</p>
      <p>You may consider a Holiday or an Event to spark ideas:</p>
      <ul>
        <li><a href="https://www.un.org/en/observances/list-days-weeks" target="_blank" rel="noopener noreferrer">United Nations Observances</a></li>
        <li><a href="https://nationaltoday.com/today/" target="_blank" rel="noopener noreferrer">National Today</a></li>
        <li><a href="https://www.onthisday.com/today/birthdays.php" target="_blank" rel="noopener noreferrer">Today's Famous Birthdays - by On This Day</a></li>
      </ul>
      <p>I hope this inspires others to think more creatively for the Retrospectives.</p>
        {seasons.map((season) => (
          <article key={season._id}>
            <h2>{season.name}</h2>
            {season.summary && <p className="indent">{season.summary}</p>}
            <dl className="indent">
                {season.startDate && <dt>Starts: {dayjs(season.startDate).format('MMMM D')}</dt>}
                {season.endDate && <dt>Ends: {dayjs(season.endDate).format('MMMM D')}</dt>}
            </dl>
            {
            season.themes && <>
                <h3>Available Themes</h3>
                <ul>
                {season.themes?.map((theme) => (
                    <li>
                        <Link to={`../theme/${theme.slug.current}`}>{(theme.theme_react_icon && <Icon icon={theme.theme_react_icon} />)}{theme.name}</Link> - {theme.description}
                    </li>
                ))}
                </ul>
            </>
            }
          </article>
        ))}
    </section>
  );
}

export default RetroTime;